import React from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.min.css';

import { updateCurrentUser } from '../api/users';
import PortalSessionContext from '../contexts/PortalSessionContext/PortalSessionContext';
import ReusableModal from './ReusableModal/ReusableModal';

const AvatarUploaderModal = ({ onClose }: { onClose: () => void }) => {
	const { user, refreshPortalUser } = React.useContext(PortalSessionContext);
	const [errors, setErrors] = React.useState<APIError>();
	const [image, setImage] = React.useState<string | ArrayBuffer | null>(null);
	const [cropper, setCropper] = React.useState<Cropper>();

	const handleFileChange = (e) => {
		setErrors(undefined);
		const file = e.target.files[0];
		const reader = new FileReader();

		reader.onloadend = () => {
			setImage(reader.result);
		};

		reader.readAsDataURL(file);
	};

	const handleSubmit = ({ removeAvatar = false } = {}) => {
		updateCurrentUser({ avatar: { image: removeAvatar ? null : getCroppedImage() } })
			.then(() => {
				setImage(null);

				refreshPortalUser();
			})
			.catch((error) => {
				setImage(null);
				setErrors(error.errors);
			});
	};

	const getCroppedImage = () => (cropper ? cropper.getCroppedCanvas().toDataURL() : null);

	const handleRemoveAvatar = () => {
		handleSubmit({ removeAvatar: true });
	};

	return (
		<ReusableModal onClose={onClose} alignTop>
			{!image ? (
				<div className="_flex _flex-col _justify-center">
					<img
						className="_w-32 _h-32 _border _rounded-full _border-primary _mx-auto"
						src={user?.avatar?.large}
						alt={user?.name}
					/>
					{user && user.avatar?.large.slice(-10) !== 'avatar.jpg' && (
						<button className="focus:_outline-none _text-danger _text-xs" onClick={handleRemoveAvatar} type="button">
							Remove Avatar
						</button>
					)}
					<label>
						<div className="_btn _btn-primary-action _my-4 _text-center _cursor-pointer">Upload Image</div>
						<input
							className="_hidden"
							type="file"
							name="image"
							onChange={handleFileChange}
							accept="image/png, image/jpeg"
						/>
					</label>
					<button className="_mb-2 _btn _btn-black" onClick={onClose}>
						Cancel
					</button>
				</div>
			) : (
				<>
					<div className="_flex _flex-col">
						<Cropper
							src={image as string}
							initialAspectRatio={1}
							minCropBoxHeight={10}
							minCropBoxWidth={10}
							background={false}
							responsive
							viewMode={1}
							guides={false}
							onInitialized={(instance) => {
								setCropper(instance);
							}}
						/>

						<button className="_mt-4 _mb-2 _btn _btn-primary-action" onClick={() => handleSubmit()} type="submit">
							Save
						</button>
						<button className="_mb-2 _btn _btn-black" onClick={onClose} type="button">
							Cancel
						</button>
					</div>
				</>
			)}
			{errors && errors.error && <div className="_mb-3 _text-center form-error">{errors.error}</div>}
		</ReusableModal>
	);
};

export default AvatarUploaderModal;
